import React, { useState, useEffect } from "react";

const OperationalExpenseModal = ({ show, expense, onClose, onSave }) => {

    const [formData, setFormData] = useState({
        amount: "",
        type: "",
        expenseDate: expense?.expenseDate !== undefined? new Date(expense.expenseDate):  new Date().toISOString().split("T")[0] // default today
    });

    useEffect(() => {
        if (expense) {
            // Ensure the date is formatted as YYYY-MM-DD
            let formattedDate = "";
            if (expense.expenseDate) {
                // This slice(0, 10) extracts 'YYYY-MM-DD' from an ISO string
                formattedDate = new Date(expense.expenseDate).toISOString().split("T")[0];
            } else {
                formattedDate = new Date().toISOString().split("T")[0];
            }

            setFormData({
                amount: expense.amount || "",
                type: expense.expenseType || "",
                expenseDate: formattedDate
            });
        } else {
            setFormData({
                amount: "",
                type: "",
                expenseDate: new Date().toISOString().split("T")[0]
            });
        }
    }, [expense, show]); // Added show here to ensure it resets when the modal opens

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Map to backend DTO format
        onSave({
            ...formData,
            expenseType: formData.type,
            expenseDate: formData.expenseDate
        });
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white w-full max-w-xl mx-auto rounded-2xl shadow-lg p-6 md:p-8">

                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-lg font-semibold text-gray-800">
                        {expense ? "Edit Expense" : "Add Expense"}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-700 text-xl"
                    >
                        &times;
                    </button>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* Amount */}
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Amount</label>
                        <input
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            placeholder="Enter amount"
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    {/* Type */}
                    <div>
                        <label className="text-sm text-gray-600 mb-1 block">Type</label>
                        <select
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        >
                            <option value="">Select Type</option>
                            <option value="TECH">Tech Cost</option>
                            <option value="STAFF">Staff Cost</option>
                            <option value="RENTAL">Rent</option>
                            <option value="MISCELLANEOUS">Miscellaneous</option>
                        </select>
                    </div>

                    {/* Date Picker */}
                    <div className="md:col-span-2">
                        <label className="text-sm text-gray-600 mb-1 block">Expense Date</label>
                        <input
                            type="date"
                            name="expenseDate"
                            value={formData.expenseDate}
                            onChange={handleChange}
                            className="w-full px-4 py-2 rounded-md border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    {/* Buttons */}
                    <div className="md:col-span-2 flex justify-end gap-3 mt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-5 py-2 text-sm bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-6 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                        >
                            {expense ? "Update" : "Save"}
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default OperationalExpenseModal;